<img src="assets/img/logo/WKAlphaFull-300x99.png" id="logo-img" class="p-mb-3 p-d-none p-d-md-flex"/>
<button 
	*ngFor="let btn of buttons"
	pButton
	pRipple
	[label]="btn.label"
	[routerLink]="btn.route" 
	(click)="linkClicked.emit(btn.route)"
	[ngClass]="getClass$(btn.route) | async"
></button>